export default __webpack_public_path__ + "static/media/banner.56d4c876.webp";